// src/Pages/Admin/AdminPanel.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import Layout from "../../Components/Layout/Layout";

function AdminPanel() {
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const authToken = localStorage.getItem("auth_token");
    if (!authToken) {
      setErrorMsg("No auth token found. Please login first.");
      setLoading(false);
      return;
    }
    // Проверяем роль: для этой страницы доступ для всех, кроме 'user'
    const userRole = localStorage.getItem("userRole");
    if (userRole && userRole !== "user") {
      setHasAccess(true);
    } else {
      setErrorMsg("Access denied: You do not have permission to view this page.");
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Layout>
        <Box sx={{ p: 2 }}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  if (!hasAccess) {
    return (
      <Layout>
        <Box sx={{ p: 2 }}>
          <Typography variant="h5">Admin Panel</Typography>
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMsg}
          </Alert>
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Box sx={{ p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Admin Reports
        </Typography>
        <Typography variant="body1" gutterBottom>
          Welcome to the admin report page.
        </Typography>
        {/* Дополнительное содержимое для отчётности */}
      </Box>
    </Layout>
  );
}

export default AdminPanel;
